var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 24.2083C18.4344 24.2094 18.2115 24.1169 18.0483 23.9517L8.715 14.6183C8.37381 14.2767 8.37381 13.7233 8.715 13.3817L18.0483 4.04835C18.3931 3.7271 18.9303 3.73658 19.2636 4.06979C19.5968 4.403 19.6063 4.94025 19.285 5.28501L10.57 14L19.285 22.715C19.6262 23.0566 19.6262 23.6101 19.285 23.9517C19.1218 24.1169 18.8989 24.2094 18.6667 24.2083Z",
    fill: "#1966FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/Chevron-Left.7030fad9ca764d539805abef8b3a5ea7.svg";
export { ForwardRef as ReactComponent };